import { Box, Card, CardContent, Grid } from '@mui/material'
import { CarrierVisitPlanningDateAxis } from '@planning/components/carrier-visit-planning/CarrierVisitPlanningDateAxis'
import { CarrierVisitPlanningHeader } from '@planning/components/carrier-visit-planning/CarrierVisitPlanningHeader'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { RailVisitPlanningViewStore } from '../../stores/RailVisitPlanningViewStore'
import { RailPlanningVisualization } from './RailPlanningVisualization'
import { RailTrackAxis } from './RailTrackAxis'

interface Props {
  store: RailVisitPlanningViewStore
  headerActions?: JSX.Element
}
export const RailVisitPlanning = observer(({ store, headerActions }: Props) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  useEffect(() => {
    const getRailtrackViewSize = () => {
      const mainElement = document.querySelector(`#planning-visualization`)

      if (mainElement) {
        store.setVisualizationWidth(Math.floor(mainElement.getBoundingClientRect().width))
      }
    }

    const handleResize = () => {
      getRailtrackViewSize()
    }

    getRailtrackViewSize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [store])

  return (
    <Card sx={{ overflowY: 'auto' }}>
      {headerActions && (
        <Box
          display='flex'
          justifyContent='flex-end'
          sx={{
            p: 1,
            borderBottom: `1px solid ${theme.palette.grey[100]}`,
          }}
        >
          {headerActions}
        </Box>
      )}
      <CardContent>
        <Grid container sx={{ paddingBottom: 2 }}>
          <Grid
            sx={{
              borderBottom: `1px solid ${theme.palette.divider}`,
            }}
            size={12}
          >
            <CarrierVisitPlanningHeader title={t('railPlan', 'Rail plan')} store={store} />
          </Grid>

          <Grid
            sx={{
              borderRight: `1px solid ${theme.palette.divider}`,
              borderBottom: `1px solid ${theme.palette.divider}`,
            }}
            size={2}
          ></Grid>

          <Grid
            sx={{
              borderBottom: `1px solid ${theme.palette.divider}`,
            }}
            size={10}
          >
            <CarrierVisitPlanningDateAxis
              itemCount={store.daysVisualization}
              startDate={store.startDate}
              pixelPerHour={store.pixelPerHour}
            />
          </Grid>

          <Grid
            sx={{
              borderRight: `1px solid ${theme.palette.divider}`,
            }}
            size={2}
          >
            <RailTrackAxis
              railTracks={store.plannedVisits.map(x => x.railTrack)}
              emptySpaceHeight={store.emptySpaceHeight}
              railTrackHeight={store.railTrackHeight}
            />
          </Grid>
          <Grid id='planning-visualization' overflow='hidden' size={10}>
            <RailPlanningVisualization
              pixelPerHour={store.pixelPerHour}
              plannedRailTrackVisits={store.plannedVisits}
              emptySpaceHeight={store.emptySpaceHeight}
              isViewMode={false}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
})
